export default {
  errors: {
    fieldsRequired: 'Vous devez ajouter au moins un champ.',
  },
};
